import DashboardCard from "./DashboardCard";
import { useSelector } from "react-redux";
import { AiOutlineLineChart } from "react-icons/ai";
import MarketOverviewLoader from "./market-overview/MarketOverviewLoader";
import MarketPreview from "./market-overview/MarketPreview";
import MarketOverviewContent from "./market-overview/MarketOverviewContent";
import CustomButton from "../../ui/CustomButton";
import { useNavigate } from "react-router-dom";
import useFetchAnalyticsInfo from "../../hooks/api/useFetchAnalyticsInfo";
import { FaArrowRight } from "react-icons/fa6";
import styles from "../../styles/Components/new-dashboard/MarketOverview.module.css";

function MarketOverview() {
  const {
    dashboard: { analyticsinfoStatus },
  } = useSelector((state) => state);

  const navigate = useNavigate();

  useFetchAnalyticsInfo();

  return (
    <DashboardCard
      type="marketOverview"
      title="Market Overview"
      titleIcon={<AiOutlineLineChart />}
      preview={<MarketPreview />}
      actions={
        <>
          {/*<LiveAiButton />*/}
          <CustomButton
            type="primary"
            className={styles.navigationBtn}
            onClick={() => navigate("/insight")}
          >
            <FaArrowRight />
            To Insights
          </CustomButton>
        </>
      }
      id="market-overview"
    >
      {analyticsinfoStatus === "loading" && <MarketOverviewLoader />}

      {analyticsinfoStatus === "success" && <MarketOverviewContent />}
    </DashboardCard>
  );
}

export default MarketOverview;
